import imageCompression from "browser-image-compression";
import { logToSentry } from "../../../../config/Sentry";

// Function to crop and resize image using object-fit: cover
const cropToCover = (dataURI, targetSize) => {
    return new Promise(function (resolve, reject) {
        // Create an HTML image element
        let img = new Image();

        // Set the source of the image
        img.src = dataURI;

        // Create a canvas element
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");

        // Set the canvas size to the target size
        canvas.width = targetSize.width;
        canvas.height = targetSize.height;

        // When the image is loaded, perform the cropping and resizing
        img.onload = function () {
            // Calculate the aspect ratios of the image and the target size
            let imageAspectRatio = img.width / img.height;
            let targetAspectRatio = targetSize.width / targetSize.height;

            let newWidth, newHeight, offsetX, offsetY;

            // Determine the cropping dimensions based on aspect ratios
            if (imageAspectRatio > targetAspectRatio) {
                // Image is wider, crop the sides
                newWidth = img.height * targetAspectRatio;
                newHeight = img.height;
                offsetX = (img.width - newWidth) / 2;
                offsetY = 0;
            } else {
                // Image is taller or square, crop the top and bottom
                newWidth = img.width;
                newHeight = img.width / targetAspectRatio;
                offsetX = 0;
                offsetY = (img.height - newHeight) / 2;
            }

            // Draw the cropped image onto the canvas
            ctx.drawImage(
                img,
                offsetX,
                offsetY,
                newWidth,
                newHeight,
                0,
                0,
                targetSize.width,
                targetSize.height
            );

            // Save the resulting image
            const croppedImage = canvas.toDataURL("image/jpeg");
            resolve(croppedImage);
        };

        img.onerror = function () {
            logToSentry("Error cropping image");
            reject(new Error("Error cropping image."));
        };
    });
};

const getCompressedImage = async (dataUri) => {
    // crop image to target size
    const croppedDataURI = await cropToCover(dataUri, {
        width: 1024,
        height: 1024,
    });

    /** dataUri to direct image file no cropping  */
    const imageFile = await imageCompression.getFilefromDataUrl(dataUri);

    const mainImgOptions = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1024,
        initialQuality: 0.9,
        fileType: "image/jpeg",
        useWebWorker: true,
    };
    const compressedFile = await imageCompression(imageFile, mainImgOptions);
    const imageUrl = await imageCompression.getDataUrlFromFile(compressedFile);

    return imageUrl;
};

const getCompressedImageWithThumbnail = async (dataUri) => {
    const croppedDataURI = await cropToCover(dataUri, {
        width: 1024,
        height: 1024,
    });

    const imageFile = await imageCompression.getFilefromDataUrl(croppedDataURI);

    const mainImgOptions = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1334,
        initialQuality: 0.9,
        fileType: "image/jpeg",
        useWebWorker: true,
    };
    const compressedFile = await imageCompression(imageFile, mainImgOptions);
    const imageUrl = await imageCompression.getDataUrlFromFile(compressedFile);

    const thumbnailOptions = {
        maxSizeMB: 0.1,
        maxWidthOrHeight: 140,
        initialQuality: 0.9,
        fileType: "image/jpeg",
        useWebWorker: true,
    };

    const compressedThumbnailFile = await imageCompression(
        imageFile,
        thumbnailOptions
    );

    const thumbnailImageUrl = await imageCompression.getDataUrlFromFile(
        compressedThumbnailFile
    );

    return {
        imageType: 1,
        imageUrl: imageUrl,
        thumbnailUrl: thumbnailImageUrl,
    };
};

export { getCompressedImage, getCompressedImageWithThumbnail };
